import { GoogleMapsContext } from 'providers/withApplicationContext';
import { PatronLocation } from 'components/patron-location/PatronLocation';
import { PatronLocationButton } from './PatronLocationButton';
import { PatronLocationInitialComponent } from './PatronLocation';
import { PatronLocationStateContext } from 'components/patron-location/PatronLocationContext';
import React, { FunctionComponent, useContext } from 'react';

export interface PatronLocationContainerProps {
  initialComponent?: PatronLocationInitialComponent;
}

export const PatronLocationContainer: FunctionComponent<PatronLocationContainerProps> = ({
  initialComponent = PatronLocationButton,
}) => {
  const { loaded: googleMapsLoaded } = useContext(GoogleMapsContext);

  const { currentPatronLocation, selectPatronLocation } = React.useContext(
    PatronLocationStateContext
  );

  const InitialComponent = initialComponent;

  return currentPatronLocation ? (
    <PatronLocation
      googleMapsLoaded={googleMapsLoaded}
      location={currentPatronLocation}
      onLocation={selectPatronLocation}
      initialComponent={initialComponent}
    />
  ) : (
    <InitialComponent loading={true} />
  );
};
